import { ApplicationSourceDto } from './applicationSource.dto';
import { BaseDto } from './base.dto';
import { CustomerDto } from './customer.dto';
import { CustomerAddressDto } from './customerAddress.dto';
import { DiscountTypeDto } from './discountType.dto';
import { EmployeeDto } from './employee.dto';
import { KerbCollectionDto } from './kerbCollection.dto';
import { MerchantDto } from './merchant.dto';
import { OrderItemDto } from './orderItem.dto';
import { OrderPaymentDto } from './orderPayment.dto';
import { OrderPosTableInfoDto } from './orderPOSTableInfo.dto';
import { OrderSerialDto } from './orderSerial.dto';
import { OrderServiceTypeDto } from './orderServiceType.dto';
import { OrderStatusDto } from './orderStatus.dto';
import { OrderStatusHistoryDto } from './orderStatusHistory.dto';
import { OrderTypeDto } from './orderType.dto';
import { ServiceChargeDto } from './serviceCharge.dto';
import { OrderReceiptPhotoDto } from './order-receipt-photo.dto';
import { CustomerLoyaltyTransactionDto } from './customerLoyaltyTransaction.dto';
import { ServiceFeeDto } from './serviceFee.dto';
import { OrderPosTableProductDto } from './orderPosTableProduct.dto';
import { CartOrderDto } from './cartOrder.dto';
import { OrderPosSplitTableInfoDto } from './orderPosSplitTableInfo.dto';

export class OrderDto extends BaseDto {
  customerId?: number;
  merchantId: number;
  source?: string;
  thirdPartyReference?: string;
  verificationCode?: string;
  requestedDate?: Date;
  feePercentage?: number;
  rating?: number;
  orderItems?: OrderItemDto[];
  customer?: CustomerDto;
  merchant?: MerchantDto;
  orderStatus?: OrderStatusHistoryDto;
  serialNo?: OrderSerialDto;
  orderSerial?: OrderSerialDto[];
  statusHistory?: OrderStatusHistoryDto[];
  orderType?: OrderTypeDto;
  clientSideId?: string;
  deliveryAddress?: CustomerAddressDto;
  deliveryFee?: number;
  deliverTime?: Date;
  totalPrice?: number;
  accepted: boolean;
  orderPayments?: OrderPaymentDto[];
  orderPosTableInfo?: OrderPosTableInfoDto[];
  orderPosSplitTableInfo?: OrderPosSplitTableInfoDto[];
  note?: string;
  processingFee?: number;
  lastOrderStatus?: OrderStatusDto;
  lastOrderStatusId?: number;
  applicationSource?: ApplicationSourceDto;
  totalBasket?: number;
  discountAmount?: number;
  discountTypeId?: number;
  discountType?: DiscountTypeDto;
  serviceChargeAmount?: number;
  serviceChargeId?: number;
  serviceCharge?: ServiceChargeDto;
  hasMainCourse: boolean;
  kerbCollection?: KerbCollectionDto;
  operatorEmployeeId?: number;
  staffEmployeeId?: number;
  compositeIdentifier?: number;
  posDeviceId?: number;
  orderLink?: string;
  orderReceiptPhotos?: OrderReceiptPhotoDto[];
  /**
   * Table Flag Number
   */
  flagNo?: number;
  /**
   * Order Service Type assigned to order
   */
  serviceType?: OrderServiceTypeDto;
  operatorEmployee?: EmployeeDto;
  selectedForLoyalty?: boolean;
  staffFoodEmployee? : EmployeeDto;
  customerLoyaltyTransactionDto?: CustomerLoyaltyTransactionDto[];
  serviceFee?: ServiceFeeDto;
  orderPosTableProducts?: OrderPosTableProductDto[];
  /** Virtual */
  paidAmount?: number;
  outstandingAmount?: number;
  cartOrders?: CartOrderDto[];
  ageVerificationCompleted: boolean;
  merchantLink?: string;
}
